<rt-slack-integration
  [isSlackIntegrationLoaded]="slackIntegrationLoaded"
  [hasSlackIntegrations]="hasSlackIntegrations"
  (integrate)="newSlackIntegration()"
  (disconnect)="disconnectAllSlackIntegrations()"
>
</rt-slack-integration>
